import { TabConfig } from "./types/GeneralTypes";

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api'


export const AllSideTabs: TabConfig[] = [
    { label: "Offense", value: "OFFENSE" },
    { label: "Defense", value: "DEFENSE" },
    { label: "Punt", value: "PUNT" },
    { label: "Punt Return", value: "PUNT_RETURN" },
    { label: "Kickoff", value: "KICKOFF" },
    { label: "Kickoff Return", value: "KICKOFF_RETURN" },
    { label: "Field Goal", value: "FIELD_GOAL" },
    { label: "FG Block", value: "FIELD_GOAL_BLOCK" },
  ];